import React, { useMemo, useState } from 'react';
import * as Yup from 'yup';
import {
  GridView,
  CrudMasterDetailView,
  Icon,
  Widget,
  CompositeView,
  MasterDetailForm,
  FormInput,
  FormSelect,
  FormTextArea,
  FormSubmitButton,
  FormatText,
  CrudContext,
  ButtonDelete,
  useRouter,
  Form,
  FormSwitch,
  FormTransfer,
  usePromise,
} from '@digital/ui';
import { TransferItem } from 'antd/lib/transfer';
import { getAllPerfilCrud, updatePerfilAcesso, getPermissoesTransfer, createPerfilAcesso } from '@app/api/PerfilAcesso';
import { hasPermission } from '@app/helpers/permissions';

const PerfilAcesso = () => {
  const [GetAllItems, setGetAllItems] = useState(() => {
    return getAllPerfilCrud;
  });

  const { history } = useRouter();

  const onCreatePerfilAcesso = (values: any) => {
    return createPerfilAcesso(values).then(resp => {
      if (resp.valid) {
        setGetAllItems(() => Promise.resolve(undefined));
        setGetAllItems(() => getAllPerfilCrud);
      }
      return resp;
    });
  };

  const onUpdatePerfilAcesso = (values: any) => {
    return updatePerfilAcesso(values).then(resp => {
      if (resp.valid) {
        setGetAllItems(() => Promise.resolve(undefined));
        setGetAllItems(() => getAllPerfilCrud);
      }
      return resp;
    });
  };

  const [dataSource] = usePromise(() => getPermissoesTransfer(), [], []);

  return (
    <CrudMasterDetailView
      getAllItems={GetAllItems}
      createItem={hasPermission(['DIRETORIA_CADASTRAR']) ? onCreatePerfilAcesso : undefined}
      updateItem={onUpdatePerfilAcesso}
      icon="security-key_security"
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.nome ? item.nome.toLowerCase().startsWith(value.toLowerCase()) : false)
      }
      disableNotification
      titleExtractor={d => d.nome}
      detailTitleExtractor={x => x.nome}
      descriptionExtractor={d => d.descricao || ''}>
      <CompositeView>
        <CrudContext.Consumer>
          {({ selectedItem }) => {
            return (
              <GridView noform>
                <MasterDetailForm
                  validationSchema={Yup.object().shape({
                    nome: Yup.string()
                      .required('Nome requerido')
                      .max(150, 'O nome deve ter no máximo 150 caracteres.'),
                    descricao: Yup.string().max(2000, 'A descrição deve ter no máximo 2000 caracteres.'),
                  })}>
                  <Widget
                    title="Perfil de Acesso"
                    actions={[
                      hasPermission(['DIRETORIA_CADASTRAR']) && (
                        <FormSubmitButton noIcon={true} type="primary">
                          <FormatText id="ui.commons.save" uppercase />
                        </FormSubmitButton>
                      ),
                    ]}>
                    <FormInput label="Nome" name="nome" span={5} />
                    <FormInput label="Descrição" name="descricao" span={5} />
                    <FormSwitch label="Perfil MRN" name="perfilMrn" span={2} />
                    <FormTransfer
                      titles={['Disponíveis', 'Associadas']}
                      listStyle={{ height: 500, width: '41%' }}
                      label="Permissões"
                      name="permissoes"
                      dataSource={dataSource}
                      render={item => item.title}
                      showSearch
                      showSelectAll
                      filterOption={(inputValue, item) =>
                        item.title.toLowerCase().includes(inputValue.toLowerCase()) ||
                        item.name.toLowerCase().includes(inputValue.toLowerCase())
                      }
                    />
                  </Widget>
                </MasterDetailForm>
              </GridView>
            );
          }}
        </CrudContext.Consumer>
      </CompositeView>
    </CrudMasterDetailView>
  );
};
export default PerfilAcesso;
